import i18next from "i18next";
import instance from "../../../../config/axios";

export async function submitData(id: number | undefined, data: any) {
    const jsonData: any = {};

    for (const key in data) {
        if(data[key] !== undefined && data[key] !== null) {
            if(key === "status"){
                jsonData['status'] = data?.status ? "1" : "0";
            } else if(key === "name"){
                jsonData[`name[${i18next?.language}]`] = data[key];
            } else if(key === "description"){
                jsonData[`description[${i18next?.language}]`] = data[key];
            } else {
                jsonData[key] = data[key];
            }
        }
    }

    const url = id ? `/subscriptions/${id}` : `/subscriptions`;
    const response = await instance({
        url,
        method: id ? "PUT" : "POST",
        data: jsonData,
        headers: {
            'Content-Type': 'application/json',
        }
    });

    return response.data;
}
